import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84992f46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title main-text" }, "注销无法完成", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, "由于以下原因，暂时无法注销账号", -1))
const _hoisted_5 = { class: "info-list van-hairline--surround van-hairline-round" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "label-line" }
const _hoisted_8 = { class: "main-text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "arrow-item" }, null, -1))
const _hoisted_10 = { class: "info-description" }
const _hoisted_11 = { class: "footer xag-page__footer nongfu-button-wrap" }

import { ref, Ref } from 'vue'
import appHost from '@/utils/app'
import getRoute from '@/compositions/route'
import AppHeader from '@/components/Header.vue'
import { useRouter } from 'vue-router'
import { Button, Toast } from 'vant'
import { GetNoPassCloseReasonItem } from '@/types/close-account'
import { getNoPassCloseReasons, requestGiveUpCloseAccount } from '@/apis/close-account'
import { showToastLoading, showConfirmModal, clearToast } from '@/utils/tools'


export default /*#__PURE__*/_defineComponent({
  __name: 'reason',
  setup(__props) {

const { query } = getRoute()
const $router = useRouter()
const infoList: Ref<GetNoPassCloseReasonItem[]> = ref()

function onLeftClick() {
  appHost.goAppBack()
}
async function giveUpLogout() {
  try {
    await showConfirmModal({
      message: '是否确认放弃注销?',
      className: 'repair-dialog',
    })
    showToastLoading()
    await requestGiveUpCloseAccount({
      apply_guid: query.value.id as string,
    })
    Toast('您已放弃注销，可以继续使用此账号')
    setTimeout(() => {
      appHost.onLogin()
    }, 2000)
  } catch (error) {
    console.log('error', error)
  }
}
function toUrl(item: GetNoPassCloseReasonItem) {
  $router.push({
    path: '/protoc',
    query: {
      title: item.name || '',
      url: item.url || 'https://app.xag.cn/help_doc/9048ef58-cd60-4f17-a232-f89aeff39607',
    },
  })
}
async function initPageData() {
  showToastLoading({ message: '加载中...' })
  try {
    const data = await getNoPassCloseReasons({ apply_guid: query.value.id as string })
    console.log('data', data)
    infoList.value = data
    clearToast()
  } catch (error) {
    console.log('error', error)
  }
}
initPageData()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "注销账号",
      isReturnLeftEvent: "",
      onLeftClick: onLeftClick
    }),
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infoList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: _normalizeClass(index === 0 ? '' : 'van-hairline--top'),
            onClick: ($event: any) => (toUrl(item))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
              _hoisted_9
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.content), 1)
          ], 10, _hoisted_6))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_unref(Button), {
        type: "success",
        round: "",
        onClick: giveUpLogout,
        block: "",
        class: "button xa-vant-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode("放弃注销")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})